export default __webpack_public_path__ + "static/media/public-green-icon.026ada96.svg";